<template>
  <div class="d-flex align-center">
    <router-link v-slot="{ navigate }" :to="redirectLink" custom>
      <div @click="navigate">
        <span class="text-subtitle-1 global-cursor-pointer d-flex align-center">
          <span v-if="adNetwork.settings.currencySignIsShown" class="text-secondary-600 mr-1">
            $
          </span>
          {{ balance }}
        </span>
      </div>
    </router-link>
    <v-hover v-slot="{ isHovering, props }">
      <c-btn
        v-bind="props"
        :loading="loading"
        icon
        :color="isHovering ? 'black' : 'secondary-600'"
        size="xs-small"
        variant="text"
        :ripple="false"
        class="no-hover ml-1"
        :icon-props="{
          icon: '$update',
          size: '16'
        }"
        @click="update()"
      />
    </v-hover>
  </div>
</template>

<script>
  import { toFixedByDefault } from '@clickadilla/components/utils'
  import { CBtn } from '@clickadilla/components/components'
  import { mapState } from 'pinia'
  import { useSettingsStore } from '@/store/settings/settings'
  import guardSections from '@/types/guard-sections'
  import routeNames from '@/types/route-names'

  export default {
    name: 'UserBalance',
    components: {
      CBtn
    },
    data() {
      return {
        loading: false,
        interval: null
      }
    },
    computed: {
      ...mapState(useSettingsStore, ['adNetwork']),
      user() {
        return this.$auth.user
      },
      balance() {
        if (!this.user) {
          return '-'
        }

        return toFixedByDefault(this.user.balance)
      },
      adNetworkHasSectionFinances() {
        return this.adNetwork.guardSections.some(({ name }) => name === guardSections.FINANCES)
      },
      redirectLink() {
        return this.adNetworkHasSectionFinances ? { name: routeNames.FINANCES } : ''
      }
    },
    created() {
      this.createUpdateInterval()
    },
    beforeUnmount() {
      clearInterval(this.interval)
    },
    methods: {
      update() {
        clearInterval(this.interval)

        this.loading = true
        this.$auth.fetchUser().finally(() => {
          this.loading = false
          this.createUpdateInterval()
        })
      },
      createUpdateInterval() {
        this.interval = setInterval(
          () => {
            this.update()
          },
          30 * 60 * 1000
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  .no-hover::before,
  .no-hover::after {
    display: none !important;
  }
</style>
